import { useEffect } from 'react';
import { logEvent } from '../logging';

export const useLoadingTimeout = (): void => {
    useEffect(() => {
        setTimeout(() => {
            if (!document.body.querySelector('[data-bot-msg="true"]')) {
                // logs to console error will be counted by appInsights
                if (window.appInsights) {
                    logEvent({
                        name: 'BotLoadTimeout',
                    });
                }
            }
        }, 10000);
        // use empty deps array so useEffect knows never to run this more than once
        // in other words, no change in props will trigger a re-execution
    }, []);
};
